/* tslint:disable */
/* eslint-disable */
/**
 * Seamworks API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { StitchNBLCTypeCreateDto } from '../model/';
// @ts-ignore
import type { StitchNBLCTypeDto } from '../model/';
// @ts-ignore
import type { StitchNBLCTypeDtoPagedResultDto } from '../model/';
// @ts-ignore
import type { StitchNBLCTypeUpdateDto } from '../model/';
/**
 * StitchNBLCTypesApi - axios parameter creator
 * @export
 */
export const StitchNBLCTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [stitchTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetNeedleCountByStitchTypeCodeGet: async (stitchTypeCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/getNeedleCountByStitchTypeCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (stitchTypeCode !== undefined) {
                localVarQueryParameter['stitchTypeCode'] = stitchTypeCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stitchTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetStitchNeedlesByStitchTypeCodeGet: async (stitchTypeCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/getStitchNeedlesByStitchTypeCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (stitchTypeCode !== undefined) {
                localVarQueryParameter['stitchTypeCode'] = stitchTypeCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchNBLCTypesGet: async (sorting?: string, skipCount?: number, maxResultCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/stitchNBLCTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchNBLCTypesIdDelete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStitchNBLCTypesIdDelete', 'id', id)
            const localVarPath = `/api/stitchNBLCTypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchNBLCTypesIdGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStitchNBLCTypesIdGet', 'id', id)
            const localVarPath = `/api/stitchNBLCTypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StitchNBLCTypeUpdateDto} [stitchNBLCTypeUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchNBLCTypesIdPut: async (id: number, stitchNBLCTypeUpdateDto?: StitchNBLCTypeUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStitchNBLCTypesIdPut', 'id', id)
            const localVarPath = `/api/stitchNBLCTypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stitchNBLCTypeUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StitchNBLCTypeCreateDto} [stitchNBLCTypeCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchNBLCTypesPost: async (stitchNBLCTypeCreateDto?: StitchNBLCTypeCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/stitchNBLCTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stitchNBLCTypeCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StitchNBLCTypesApi - functional programming interface
 * @export
 */
export const StitchNBLCTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StitchNBLCTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [stitchTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetNeedleCountByStitchTypeCodeGet(stitchTypeCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetNeedleCountByStitchTypeCodeGet(stitchTypeCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StitchNBLCTypesApi.apiGetNeedleCountByStitchTypeCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [stitchTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetStitchNeedlesByStitchTypeCodeGet(stitchTypeCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetStitchNeedlesByStitchTypeCodeGet(stitchTypeCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StitchNBLCTypesApi.apiGetStitchNeedlesByStitchTypeCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStitchNBLCTypesGet(sorting?: string, skipCount?: number, maxResultCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StitchNBLCTypeDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStitchNBLCTypesGet(sorting, skipCount, maxResultCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StitchNBLCTypesApi.apiStitchNBLCTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStitchNBLCTypesIdDelete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStitchNBLCTypesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StitchNBLCTypesApi.apiStitchNBLCTypesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStitchNBLCTypesIdGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StitchNBLCTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStitchNBLCTypesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StitchNBLCTypesApi.apiStitchNBLCTypesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {StitchNBLCTypeUpdateDto} [stitchNBLCTypeUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStitchNBLCTypesIdPut(id: number, stitchNBLCTypeUpdateDto?: StitchNBLCTypeUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StitchNBLCTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStitchNBLCTypesIdPut(id, stitchNBLCTypeUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StitchNBLCTypesApi.apiStitchNBLCTypesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StitchNBLCTypeCreateDto} [stitchNBLCTypeCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStitchNBLCTypesPost(stitchNBLCTypeCreateDto?: StitchNBLCTypeCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StitchNBLCTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStitchNBLCTypesPost(stitchNBLCTypeCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StitchNBLCTypesApi.apiStitchNBLCTypesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StitchNBLCTypesApi - factory interface
 * @export
 */
export const StitchNBLCTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StitchNBLCTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [stitchTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetNeedleCountByStitchTypeCodeGet(stitchTypeCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiGetNeedleCountByStitchTypeCodeGet(stitchTypeCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [stitchTypeCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetStitchNeedlesByStitchTypeCodeGet(stitchTypeCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiGetStitchNeedlesByStitchTypeCodeGet(stitchTypeCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchNBLCTypesGet(sorting?: string, skipCount?: number, maxResultCount?: number, options?: RawAxiosRequestConfig): AxiosPromise<StitchNBLCTypeDtoPagedResultDto> {
            return localVarFp.apiStitchNBLCTypesGet(sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchNBLCTypesIdDelete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiStitchNBLCTypesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchNBLCTypesIdGet(id: number, options?: RawAxiosRequestConfig): AxiosPromise<StitchNBLCTypeDto> {
            return localVarFp.apiStitchNBLCTypesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StitchNBLCTypeUpdateDto} [stitchNBLCTypeUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchNBLCTypesIdPut(id: number, stitchNBLCTypeUpdateDto?: StitchNBLCTypeUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<StitchNBLCTypeDto> {
            return localVarFp.apiStitchNBLCTypesIdPut(id, stitchNBLCTypeUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StitchNBLCTypeCreateDto} [stitchNBLCTypeCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStitchNBLCTypesPost(stitchNBLCTypeCreateDto?: StitchNBLCTypeCreateDto, options?: RawAxiosRequestConfig): AxiosPromise<StitchNBLCTypeDto> {
            return localVarFp.apiStitchNBLCTypesPost(stitchNBLCTypeCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StitchNBLCTypesApi - object-oriented interface
 * @export
 * @class StitchNBLCTypesApi
 * @extends {BaseAPI}
 */
export class StitchNBLCTypesApi extends BaseAPI {
    /**
     * 
     * @param {string} [stitchTypeCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StitchNBLCTypesApi
     */
    public apiGetNeedleCountByStitchTypeCodeGet(stitchTypeCode?: string, options?: RawAxiosRequestConfig) {
        return StitchNBLCTypesApiFp(this.configuration).apiGetNeedleCountByStitchTypeCodeGet(stitchTypeCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [stitchTypeCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StitchNBLCTypesApi
     */
    public apiGetStitchNeedlesByStitchTypeCodeGet(stitchTypeCode?: string, options?: RawAxiosRequestConfig) {
        return StitchNBLCTypesApiFp(this.configuration).apiGetStitchNeedlesByStitchTypeCodeGet(stitchTypeCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StitchNBLCTypesApi
     */
    public apiStitchNBLCTypesGet(sorting?: string, skipCount?: number, maxResultCount?: number, options?: RawAxiosRequestConfig) {
        return StitchNBLCTypesApiFp(this.configuration).apiStitchNBLCTypesGet(sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StitchNBLCTypesApi
     */
    public apiStitchNBLCTypesIdDelete(id: number, options?: RawAxiosRequestConfig) {
        return StitchNBLCTypesApiFp(this.configuration).apiStitchNBLCTypesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StitchNBLCTypesApi
     */
    public apiStitchNBLCTypesIdGet(id: number, options?: RawAxiosRequestConfig) {
        return StitchNBLCTypesApiFp(this.configuration).apiStitchNBLCTypesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StitchNBLCTypeUpdateDto} [stitchNBLCTypeUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StitchNBLCTypesApi
     */
    public apiStitchNBLCTypesIdPut(id: number, stitchNBLCTypeUpdateDto?: StitchNBLCTypeUpdateDto, options?: RawAxiosRequestConfig) {
        return StitchNBLCTypesApiFp(this.configuration).apiStitchNBLCTypesIdPut(id, stitchNBLCTypeUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StitchNBLCTypeCreateDto} [stitchNBLCTypeCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StitchNBLCTypesApi
     */
    public apiStitchNBLCTypesPost(stitchNBLCTypeCreateDto?: StitchNBLCTypeCreateDto, options?: RawAxiosRequestConfig) {
        return StitchNBLCTypesApiFp(this.configuration).apiStitchNBLCTypesPost(stitchNBLCTypeCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}

